import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-trash-icon',
  templateUrl: './general-trash.component.html'
})
export class GeneralTrashComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
